import { render, staticRenderFns } from "./SliderSlide.vue?vue&type=template&id=2ac31116"
import script from "./SliderSlide.vue?vue&type=script&lang=js"
export * from "./SliderSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports